export const generalData = [
  {
    value: 'firstName',
    label: 'Nombre(s) del estudiante *',
    disabled: true
  },
  {
    value: 'lastName',
    label: 'Apellido(s) *',
    disabled: true
  },
  {
    value: 'email',
    label: 'Correo electrónico *',
    disabled: true
  }
];
